export const messages = {
  title: { id: 'admin/promotions.form.conditions.list-price.title' },
  subtitle: {
    id: 'admin/promotions.form.conditions.list-price.subtitle',
  },
  moreInformation: {
    id: 'admin/promotions.links.conditions.list-price.more-information',
  },
  editor: {
    radioGroup: {
      id: 'admin/promotions.form.conditions.list-price.editor.radio-group',
    },
    defined: {
      title: {
        id: 'admin/promotions.form.conditions.list-price.editor.defined.title',
      },
      description: {
        id: 'admin/promotions.form.conditions.list-price.editor.defined.description',
      },
    },
    notDefined: {
      title: {
        id: 'admin/promotions.form.conditions.list-price.editor.not-defined.title',
      },
      description: {
        id: 'admin/promotions.form.conditions.list-price.editor.not-defined.description',
      },
    },
  },
  view: {
    title: { id: 'admin/promotions.form.conditions.list-price.view.title' },
    description: {
      id: 'admin/promotions.form.conditions.list-price.view.description',
    },
  },
}
